"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInvestmentId = exports.dispatchInvestmentId = exports.INVESTMENT_ID_TOPIC = void 0;
const react_1 = require("react");
const elements_core_event_bus_1 = require("@hydrogen/elements.core.event-bus");
const elements_core_router_1 = require("@hydrogen/elements.core.router");
exports.INVESTMENT_ID_TOPIC = 'INVESTMENT_ID_TOPIC';
const dispatchInvestmentId = (id) => (0, elements_core_event_bus_1.post)(exports.INVESTMENT_ID_TOPIC, { id });
exports.dispatchInvestmentId = dispatchInvestmentId;
function useInvestmentId() {
    const [investId, setInvestId] = (0, react_1.useState)(null);
    const { investmentId } = (0, elements_core_router_1.useParams)();
    (0, react_1.useEffect)(() => {
        const unsubscriber = (0, elements_core_event_bus_1.subscribe)(exports.INVESTMENT_ID_TOPIC, ({ id }) => {
            setInvestId(id);
        });
        return () => {
            unsubscriber();
        };
    }, []);
    return +(investmentId || 0) || investId;
}
exports.useInvestmentId = useInvestmentId;
//# sourceMappingURL=use-investment-id.js.map